import React, { forwardRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { addFieldValue, inspectionSelector } from "../../redux/inspectionSlice";
import { addNewLookup, lookupSelector } from "../../redux/lookupSlice";
import {
  addInspection,
  surveySelector,
  updateInspection,
  updateSurveyInspection,
} from "../../redux/surveySlice";
import { api } from "../../services/api-service";

const StepControl = forwardRef(({ active, setActive, onClose, index }, ref) => {
  const inspection = useSelector(inspectionSelector);
  const survey = useSelector(surveySelector);

  const lookup = useSelector(lookupSelector);
  const dispatch = useDispatch();
  const handleBack = () => {
    switch (active) {
      case "upload":
        setActive("addInfo");
        return;
      case "preview":
        setActive("upload");
        return;
      default:
        return;
    }
  };

  const handleNext = () => {
    switch (active) {
      case "addInfo":
        setActive("upload");
        return;
      case "upload":
        setActive("preview");
        return;
      default:
        return;
    }
  };

  const handleSubmit = async () => {
    checkLookups();
    if (inspection.sketch?.paths.length > 0) {
      const formdata = new FormData();
      formdata.append("file", getFileFromBase64(inspection.sketch.url));
      const response = await api.post("upload", formdata);
      if (response.ok) {
        dispatch(
          addFieldValue({
            field: "sketch",
            subfield: "url",
            value: response.data.data,
          })
        );
      }
    }
    if (index === -1) {
      dispatch(addInspection(inspection));
    } else {
      dispatch(updateInspection({ index, inspection }));
      if (inspection.id) {
        dispatch(
          updateSurveyInspection({ inspection: inspection, survey: survey })
        );
      }
    }
    setActive("addInfo");
    onClose();
  };

  const getFileFromBase64 = (dataUrl) => {
    var arr = dataUrl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], "file.png", { type: mime });
  };

  const checkLookups = () => {
    const keys = Object?.keys(lookup);
    keys.forEach(async (key) => {
      const splittedKey = key.split(":");
      const value = splittedKey[1]
        ? inspection[splittedKey[0]][splittedKey[1]]
        : inspection[splittedKey[0]];
      if (value && lookup[key]?.findIndex((look) => look.id === value) === -1) {
        dispatch(addNewLookup({ key, value }));
      }
    });
  };

  return (
    <Modal.Footer>
      {active !== "addInfo" && (
        <button
          className="btn cta-primary-light px-4"
          onClick={() => handleBack()}
        >
          Back
        </button>
      )}
      {active !== "preview" && (
        <button
          className="btn cta-primary-light px-4"
          onClick={() => handleNext()}
        >
          Next
        </button>
      )}
      {active === "preview" && (
        <button
          className="btn cta-primary-light px-4"
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      )}
    </Modal.Footer>
  );
});

export default StepControl;
